
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
// import { OwlOptions } from 'ngx-owl-carousel-o';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { AuthService } from 'src/app/services/auth.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';
import { TokenStorageService } from '../../services/token-storage.service';
import { RoleService } from 'src/app/services/role.service';
import { UserService } from 'src/app/services/user.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from 'src/app/_helpers/utility';
import * as moment from 'moment';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { SubscribeService } from '../service/subscribeService.service';
import { CategoryService } from "src/app/services/category.service";
import { ReviewsService } from 'src/app/services/reviews.service';
import { CommonService } from "src/app/services/common.service";
import { TournamentsService } from 'src/app/services/tournamnet.service';
const frontEnd = environment.frontEnd;


const passEndDate = moment(environment.passEndDate).format('YYYY-MM-DD');
const currentDate = moment().format('YYYY-MM-DD');

@Component({
  selector: 'page-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [ConfirmationService, MessageService, HeaderComponent],
})

export class HeaderComponent implements OnInit {
     position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
       public downloadModal: boolean = false;
       public mobileMenues: boolean = false;
  mobileLoginForm: FormGroup;
  public countryCodeList: any[] = [];
  loading = false;
  notificationNotSeen = true;
  informationList: boolean = false;
  downloadAppModal: boolean = false;
  downloadAffiliateModal: boolean = false;
  notificationListpoup: boolean = false;
  isDivToggled = false;
  public referralcode;
  loginRegisterModal: boolean;

  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12
    },
    {
      breakpoint: '768px',
      numVisible: 12,
      numScroll: 12
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  signUpForm: FormGroup;
  loginForm: FormGroup;
  submitted: boolean = false;
  loginFormSubmitted: boolean = false;
  genders;
  message;
  showMessage: boolean = false;
  selectedGender: any = null;
  userType;
  userData;
  isLoginFailed: boolean;
  isLoggedIn: boolean;
  roles;
  trainerRoleId;
  permissions: any[] = [];
  permissionArray: any[] = [];
  userTypeListArray: any[] = [];
  rolelist: any[] = [];
  errorMessage; finalnotificationList: any[];
  notificationList: any[];
  tmpnotificationList: any;
  mobile: boolean = false;
  ipAddress;
  yearRange;
  minDateValue: Date;
  minYear = environment.minYear;
  parentcatList: any[] = [];
  showGenderError;
  public loggedInUser;
  public userId;
  public shareurl;
  public menus: any[] = [];
  public showMenus;
  public areas;
  public selectedArea;
  public activeIndex: number = 0;
  public birthYearRange;
  public birthYearDefaultDate;
  public birthMinValue: Date = new Date(environment.defaultDate);
  public birthMaxValue: Date = new Date(maxYearFunction());
  public partnerList;
  public loggedInUsername;
  public loggedInProfilePic;
  public roleFilteredArr;
  usercategories: any;
  public isAcademy: boolean = false;
  public showAcademymenu: boolean = false;
  public totalCash = 0;
  public totalCoins = 0;
  public totalAvailableCash = 0;
  public totalDeductedCash = 0;
  public totalDeductedCoin = 0;
  public totalAvailableCoins = 0;
  public ticketPresent: boolean = false;
  public item;
  public totalCount: any
  public pagenumber = 1;
  // partnelist : partner
  public academyReviewCount: number = 0;
  public academyId;
  doSecondTabDisplay: boolean;
  tournamentType: any;
  isNotificationRead: boolean = false;
  passEndDate: string;
  currentDate: string;
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableContestCash: number;
  isAndroid: boolean;
  /*slider */

  liveMatchesList: any[] = [];
  liveMatches = {
    effect: 'slide',
    loop: false,
    navigation: {
      nextEl: '.rightIndicator',
      prevEl: '.leftIndicator',
    },
    // pagination: {
    //   el: ".swiper-pagination",
    //   type: "bullets",
    //   clickable: true,
    // },
    breakpoints: {
      768: {
        slidesPerView: 1
      },
      992: {
        slidesPerView: 1
      },
      1200: {
        slidesPerView: 1
      }
    }
  };
  selectedCountryCode: any;
  playerRank: number;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: RoleService,
    private http: HttpClient,
    private cd: ChangeDetectorRef,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private subscribeservice: SubscribeService,
    private userWalletService: UserWalletService,
    private userService: UserService,
    private categoryService: CategoryService,
    private academyReviewService: ReviewsService,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private tournamentsService: TournamentsService
  ) { }
  ngOnInit() {
    this.getCountryCodes();
    this.liveMatchesList = [
      {
        matchRound: "Final",
        matchRoundName: 'Centre Court',
        player1Flag: "assets/images/header/flg1.png",
        player1Order: "1",
        player1Name: "J. Sinner",
        player1matchStatus: "winner",
        player1Points: [
          4, 6, 6, 6,
        ],
        player2Flag: "assets/images/header/flg2.png",
        player2Order: "2",
        player2Name: "C. Alcaraz",
        player2matchStatus: "loser",
        player2Points: [
          6, 4, 4, 4,
        ],
      },
      {
        matchRound: "Final",
        matchRoundName: 'Centre Court',
        player1Flag: "assets/images/header/flg1.png",
        player1Order: "1",
        player1Name: "J. Sinner",
        player1matchStatus: "loser",
        player1Points: [
          4, 6, 6, 6,
        ],
        player2Flag: "assets/images/header/flg2.png",
        player2Order: "2",
        player2Name: "C. Alcaraz",
        player2matchStatus: "winner",
        player2Points: [
          6, 4, 4, 4,
        ],
      },
      {
        matchRound: "Final",
        matchRoundName: 'Centre Court',
        player1Flag: "assets/images/header/flg1.png",
        player1Order: "1",
        player1Name: "J. Sinner",
        player1matchStatus: "loser",
        player1Points: [
          4, 6, 6, 6,
        ],
        player2Flag: "assets/images/header/flg2.png",
        player2Order: "2",
        player2Name: "C. Alcaraz",
        player2matchStatus: "winner",
        player2Points: [
          6, 4, 4, 4,
        ],
      },


    ];

    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isAndroid = userAgent.includes('android') ? true : false;
    this.activatedRoute.queryParams.subscribe((res) => {
      this.tournamentType = res.tournamentType;
    })
    this.roleFilteredArr = environment.roleFilteredArray;
    this.getRoles();
    this.loggedInUser = this.tokenStorage.getUser();
    this.passEndDate = passEndDate
    this.currentDate = currentDate

    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      if (this.loggedInUser.userdata.rolename == "academy") {
        this.loggedInUsername = this.loggedInUser.userdata.academyname;
        this.loggedInProfilePic = this.loggedInUser.userdata.academypic;
        let academyPaymentDetails = this.loggedInUser.userdata.academyPaymentDetails;
        this.isAcademy = true;
        this.academyId = this.loggedInUser.userdata.academyId;
        this.getAcademyReviewCount();
        if (Object.keys(academyPaymentDetails).length > 0) {
          if (academyPaymentDetails.academyPaymentStatus == 'paid' || academyPaymentDetails.academyPaymentStatus == 'free') {
            this.showAcademymenu = true;
          } else {
            this.showAcademymenu = false;
          }
        }
        this.doSecondTabDisplay = this.isAcademy && this.showAcademymenu;
      } else {
        this.loggedInUsername = this.loggedInUser.userdata.fullName;
        this.loggedInProfilePic = this.loggedInUser.userdata.profilepic;
        this.userId = this.loggedInUser.userdata.id;
        this.isAcademy = false;
        this.ticketPresent = this.loggedInUser.userdata.isMyTicket;
        this.getUserDetails(this.userId);
        this.doSecondTabDisplay = true;
      }
      this.userId = this.loggedInUser.userdata.id;
      this.getUserBalance();
      this.getPlayerRankingDetails();
      this.onLazyLoadNotification();

    }
    if (this.isLoggedIn == true) {
      this.loginRegisterModal = false;
    }
    this.minDateValue = new Date();
    this.yearRange = this.minYear + ":" + maxYearFunction();
    this.mobileLoginForm = this.formBuilder.group({
      phoneCode: [null],
      mobileNumber: [null]
    });
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.signUpForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-]+( [a-zA-Z',.-]+)*){2,30}")]],
      //lastName: ['', [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')]],
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      password: ['', [Validators.required, Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]],
      confirmPassword: ['', Validators.required],
      //gender: ['', Validators.required],
      dob: ['',],
      mobileNumber: ['', [Validators.required, Validators.pattern("[0-9 ]{10}")]],
      role: ['user'],
      userType: ['user']
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
    this.genders = [
      { id: '1', name: 'Male', code: 'Male' },
      { id: '2', name: 'Female', code: 'Female' },
      { id: '3', name: 'Other', code: 'Other' },
    ];
    this.selectedGender = this.genders[0];

    this.birthYearRange = this.minYear + ":" + maxYearFunction();
    this.birthMaxValue = new Date(moment(this.birthMaxValue.setFullYear(this.birthMaxValue.getFullYear() + 1)).format('YYYY-MM-DD'));
    this.birthYearDefaultDate = new Date(moment(this.birthMaxValue).subtract(1, "d").format('YYYY-MM-DD'));
  }
  getCountryCodes() {
    this.commonService.getCountryList().subscribe((data) => {
      this.countryCodeList = data.data.items;
      this.setInitialCountryCode();
    })
  }
  setInitialCountryCode() {
    this.mobileLoginForm.get('phoneCode').setValue(this.countryCodeList.find(ele => ele.name === 'India'));
    this.selectedCountryCode = this.countryCodeList.find(ele => ele.name === 'India');
  }
  setCountryCode(event) {
    this.selectedCountryCode = event.value;
  }
  // convenience getter for easy access to form fields
  get f() {
    return this.signUpForm.controls;
  }
  get loginf() {
    return this.loginForm.controls;
  }
  onGenderSelect(gender, event) {
    this.selectedGender = '';
    if (event.isTrusted) {
      this.selectedGender = gender;
    }
  }
  onAreaChange(event) {
    if (event.value != null) {
      this.selectedArea = event.value.name;
    }
  }
  getUserDetails(userId) {
    this.userService.getUserDetails(userId).subscribe(
      data => {

        this.item = data;

        if (this.item) {
          this.referralcode = this.item.referral_code;
          const heading = 'Hey there,';
          const subheading = "I've been using TPL App and it's been amazing! 👌 ";
          const titleparagraph = "If you're interested in trying it out, I have a referral code that can give you *1000 TPL Coins* when you sign up. ";
          const ReferralCode = "Here's my referral code: *" + this.referralcode + "*\n";
          const referralCodeLink = "\nClick to Signup: " + frontEnd.domain + "/sign-up?ref=" + this.referralcode;
          const ReferralCodeinfo = "\nLet me know if you have any questions or need more info. ";

          const currentPageLink = window.location.href;

          const pagelink = '*' + currentPageLink + '*';

          // const org = 'For inquiries, contact ' + this.academyName + ' at ' + this.organizercontactnumber + '.';
          const text = 'Lets hit the court together and make this tournament an unforgettable experience! 🎾🏆';
          const seeyou = 'Cheers!';
          const phoneNumber = '1234567890'; // Replace with the recipient's phone number

          const siteIconUrl = 'https://www.tplsport.com/favicon.ico'; // Replace with your site's icon URL

          // Construct the WhatsApp sharing URL
          const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + titleparagraph + '\n' + '\n' + ReferralCode + referralCodeLink + '\n' + '\n' + ReferralCodeinfo + '\n' + '\n' + seeyou + '\n' + '\n' + '\n');
          //console.log(message);
          this.shareurl = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;
        }
      }, err => {
      });
  }
  shareWhatsApp() {
    const heading = 'Hey there,';
    const subheading = "I've been using TPL App and it's been amazing! 👌 ";
    const titleparagraph = "If you're interested in trying it out, I have a referral code that can give you *1000 TPL Coins* when you sign up. ";
    const ReferralCode = "Here's my referral code: *" + this.referralcode + "*\n";
    const referralCodeLink = "\nClick to Signup: " + frontEnd.domain + "/sign-up?ref=" + this.referralcode;
    const ReferralCodeinfo = "\nLet me know if you have any questions or need more info. ";

    const currentPageLink = window.location.href;
    const pagelink = '*' + currentPageLink + '*';

    // const org = 'For inquiries, contact ' + this.academyName + ' at ' + this.organizercontactnumber + '.';
    const text = 'Lets hit the court together and make this tournament an unforgettable experience! 🎾🏆';
    const seeyou = 'Cheers!';
    const phoneNumber = '1234567890'; // Replace with the recipient's phone number

    const siteIconUrl = 'https://www.tplsport.com/favicon.ico'; // Replace with your site's icon URL

    // Construct the WhatsApp sharing URL
    const message = encodeURIComponent(heading + '\n' + '\n' + subheading + '\n' + '\n' + titleparagraph + '\n' + '\n' + ReferralCode + referralCodeLink + '\n' + '\n' + ReferralCodeinfo + '\n' + '\n' + seeyou + '\n' + '\n' + '\n');
    console.log(message);
    const url = `https://api.whatsapp.com/send?text=${message}&link=${currentPageLink}&image=${siteIconUrl}`;

    window.open(url, '_blank');
  }

  getUserBalance() {
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe(
      data => {
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalContestCash = data.data.totalContestCash;
        this.totalDeductedContestCash = data.data.totalDeductedContestCash;
        this.totalAvailableContestCash = this.totalContestCash - this.totalDeductedContestCash;
      },
      err => {
        this.errorMessage = err.error.message;
      })
  }

  getPlayerRankingDetails() {
    const query = '';
    this.tournamentsService.tournamentLeaderPlayerscore(this.userId,query).subscribe((data:any) => {
      this.playerRank = data['totalRank'];
    }, err => {
      this.errorMessage = err.error.message;
    })
  }

  openWallet() {
    this.router.navigate(['my-wallet']);
  }

  getRoleDetails() {
    const querystring = "filterByroleId=" + this.userData.data.userdata.role;
    this.roleService.searchRoleDetails(querystring).subscribe(
      data => {
        this.trainerRoleId = data.data.items[0]['id'];
        this.permissions = data.data.items[0]['permissions'];
        this.tokenStorage.saveUserPermissions(this.permissions);
        this.rolelist = data.data.items[0];
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  findIndexByIdArray(name, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].rolename === name) {
        index = i;
        break;
      }
    }
    return index;
  }
  getRoleList() {
    var querystring = "filterByDisable=false&filterByStatus=true";
    var rolearray = [];
    this.roleService.getRoleList(querystring).subscribe(
      data => {
        var rolelist = data.data.items;
        rolelist.forEach(element => {
          rolearray.push({ "roleid": element.id, "rolename": element.user_role_name });
        });
        if (rolearray.length > 0) {
          this.tokenStorage.saveRolelist(rolearray);
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  onSubmit(): void {
    this.loginFormSubmitted = true;
    //stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }
    const username = this.loginForm.value.email;
    const password = this.loginForm.value.password;
    this.userType = 'user';
    this.authService.login(username, password, this.userType, false).subscribe(
      data => {
        this.userData = data;
        this.tokenStorage.saveToken(this.userData.data.access_token);
        this.tokenStorage.saveUser(this.userData.data);
        this.tokenStorage.getAuthStatus(this.userData.data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.getRoleDetails();
        this.getRoleList();
        this.getParentCategory();
        let currentUrl = '/';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
        this.loginRegisterModal = false;
      },
      ((err) => {
        this.errorMessage = 'Please check your login credentials...! ';
        this.isLoginFailed = true;
        this.messageService.add({ key: 'usertoastmsg', severity: 'error', summary: this.errorMessage, detail: 'Login Failed', life: 6000 });
      })
    );
  }
  getParentCategory() {
    var query = "?filterByDisable=false&filterByStatus=true&getOnlyParent=true";
    this.categoryService.getCategoryList(query).subscribe(
      data => {
        this.parentcatList = data.data.items;
        this.tokenStorage.saveCategorylist(this.parentcatList);
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onSignupSubmit(): void {
    this.submitted = true;
    //stop here if form is invalid
    if (this.signUpForm.invalid) {
      return;
    }
    let userData = this.signUpForm.value;

    // if (this.selectedGender == null) {
    //   this.showGenderError = true;
    //   return;
    // }
    userData['gender'] = '';
    userData['role'] = 'user';
    userData['name'] = userData['name'].split(" ", 2);
    let firstName = userData['name'][0];
    let lastName = userData['name'][1];
    userData['firstName'] = firstName;
    userData['lastName'] = lastName;

    this.authService.signUp(userData).subscribe(
      data => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Added', life: 3000 });
        this.signUpForm.reset();
        this.submitted = false;
        this.loginRegisterModal = false;
        setTimeout(() => {
          this.loginRegisterModal = true;
          this.activeIndex = Number(0);
        }, 2000);
      },
      ((err) => {
        this.showMessage = true;
        this.message = err.error.error;
        this.messageService.add({ key: 'usertoastmsg', severity: 'error', summary: err.error.error, detail: 'Add User Failed', life: 6000 });
      })
    );
  }
  showLoginRegisterDialog() {
    if (this.isLoggedIn == true) {
      this.loginRegisterModal = false;
    } else {
      this.loginRegisterModal = true;
    }
  }
  signOut() {
    const localStorageFullAndroidCondition = localStorage.getItem('fullAndroid');
    const fullAndroid = localStorageFullAndroidCondition && JSON.parse(localStorageFullAndroidCondition);
    window.sessionStorage.clear();
    this.tokenStorage.isLoggedOut();
    let currentUrl = '/';
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    if (fullAndroid) {
      this.router.navigate([currentUrl], { queryParams: { fullAndroid: true } });
    } else {
      this.router.navigate([currentUrl]);
    }
    return false;
  }
  toggleCanvas() {

  }
  toggleSearch() {

  }
  showMenu() {
    this.showMenus = true;
  }
  myProfile() {
    this.router.navigateByUrl("/my-profile");
  }
  signIn() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['sign-in']);
    });
    //this.router.navigateByUrl("sign-in");
  }
  signUp() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['sign-up']);
    });
  }
  signInSignUp() {
    this.router.navigate(['/']);
    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    // });
  }
  playercategory: any
  onClick(event) {
    let playercategory = event
    this.subscribeservice.passpartnerID(playercategory);
    this.router.navigate(['find-partner'], { queryParams: { page: 1, limit: 10 } })
  }

  onNavigateToMyContest() {
    let initialMyContestPaginationvalues = { page: 1, limit: 10, tab: 0 }
    window.localStorage.setItem('my-contest-pagination', JSON.stringify(initialMyContestPaginationvalues));
  }

  onNavigateToTournaments() {
    let initialTournamentPaginationvalues = { page: 1, limit: 10, tab: 2 }
    window.localStorage.setItem('tournament-pagination', JSON.stringify(initialTournamentPaginationvalues));
  }

  getRoles() {
    let query = "filterByDisable=false";
    this.roleService.getRoleListWithoutAuth(query).subscribe(data => {
      if (data.data.items) {
        let rolesArray = data.data.items;
        this.roleFilteredArr.forEach(role => {
          let rIndex = this.findSelectedIndexByRole(role, rolesArray);
          if (rIndex != -1) {
            rolesArray.splice(rIndex, 1);
          }
        })
        this.usercategories = rolesArray;
      }
    })
  }

  findSelectedIndexByRole(role, arrayName) {
    let index = -1;
    for (let i = 0; i < arrayName.length; i++) {
      if (arrayName[i].user_role_name === role) {
        index = i;
        break;
      }
    }
    return index;
  }

  showInformationlist() {
    this.informationList = true;
  }
  backInformationBtn() {
    this.informationList = false;
  }
  toggleDivClass() {
    this.isDivToggled = true;
  }
  backNotification() {
    this.isDivToggled = false;

  }


  // Notification list start
  items: any[] = [];
  lazyLoading: boolean = true;

  loadLazyTimeout: any;
  popNotification(id) {
    console.log(id);
    // this.finalnotificationList = this.finalnotificationList.filter(el=>el.id!=id)
  }

  onLazyLoadNotification() {
    this.loading = true;
    let rows;
    rows = 10;
    const query = "?filterByStatus=true&filterByDisable=false&filterByRead=false&filterByUserId=" + this.userId + "&sortBy=created_at&orderBy=DESC";
    const params = "";
    const updatedQuery = `${query}&pageSize=${rows}&pageNumber=${this.pagenumber}${params}`;
    this.loading = false;
    this.notificationList = Object.assign([], this.finalnotificationList);
    this.userWalletService.getUserNotificationList(updatedQuery).subscribe(
      (data) => {
        // this.lazyLoading = false;
        // this.items = data.data.items;
        this.totalCount = data.data.totalCount;

        // this.tmpnotificationList = data.data.items;
        // if (!this.isNotificationRead) {
        //   this.finalnotificationList = [...this.notificationList, ...this.tmpnotificationList];
        // } else {
        //   this.finalnotificationList = [...this.tmpnotificationList];
        // }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );

  }
  //test for scroll up and down
  loadMoreData(scrollDirection: 'start' | 'end') {
    const pageSize = 10; // Load exactly 10 new rows each time
    const first = scrollDirection === 'start' ? 0 : this.items.length;
    console.log(`Scroll direction: ${scrollDirection}`);
    alert(`Scroll direction: ${scrollDirection}`);
    this.onLazyLoadNotification();
  }
  //test for scroll up and down end

  // On Click load data
  loadMoreNotification() {
    this.pagenumber++;
    this.isNotificationRead = false;
    this.onLazyLoadNotification();
  }
  //testing for notification seen icon hide
  selectedItemIndex: number | null = null;
  markNotificationRead(id, frommobile): void {

    var userNotificationData = '{"read": true}';
    this.finalnotificationList[this.findIndexById(id)].read = true;
    this.pagenumber = 1;
    this.userWalletService.updateReadFlag(id, userNotificationData).subscribe(
      data => {
        this.finalnotificationList = [];
        this.totalCount = data.totalCount;
        if (frommobile) {
          this.notificationListpoup = false;
        }
        this.isNotificationRead = true;
        this.onLazyLoadNotification();
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );

  }
  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.finalnotificationList.length; i++) {
      if (this.finalnotificationList[i].id === id) {
        index = i;
        break;
      }
    }
    return index;
  }
  // Notification list end
  getAcademyReviewCount() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByAcademyId=" + this.academyId;
    this.academyReviewService.getReviewsList(query).subscribe(
      data => {
        this.academyReviewCount = data.data.totalCount;
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  NotificationPopup() {
    this.notificationListpoup = true;
  }
  downloadApp() {
    this.downloadAppModal = true;
  }

  downloadAfilliateAcademy() {
    this.downloadAffiliateModal = true;
  }
  mobileMenu() {
    this.mobileMenues = true;

  }
onDownloadClick(position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright'){
  this.position = position;
  this.downloadModal = true; 
}


readonly APP_LINKS = {
  player: {
    android: 'https://play.google.com/store/apps/details?id=com.wiantech.tplsport',
    ios: 'https://apps.apple.com/in/app/tpl-app/id6461867254'
  },
  partner: {
    android: 'https://play.google.com/store/apps/details?id=com.tplsport.tplacademy',
    ios: 'https://apps.apple.com/in/app/tpl-partner/id6759315694'
  }
};

openApp(url: string): void {
  window.open(url, '_blank', 'noopener,noreferrer');
}


}
